import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuthSession } from '../context/AuthSessionContext'
import { resolvePostLoginPath } from '../lib/postLoginPath'

/**
 * 仅游客可访问（登录页）：已登录则跳回业务首页或来源页。
 */
export function GuestOnly() {
  const location = useLocation()
  const { isLoggedIn, hydrateFromStorage } = useAuthSession()

  useEffect(() => {
    hydrateFromStorage()
  }, [hydrateFromStorage])

  if (!isLoggedIn) {
    return <Outlet />
  }

  const fromState = (location.state as { from?: { pathname?: string } } | null)?.from
    ?.pathname
  return <Navigate to={resolvePostLoginPath(fromState)} replace />
}
